import { addDaysToDate, parseTaskDate, toCalendarISOString } from '@utils/dateOnlyParser';
import { computeProjectRange, ProjectRange } from './computeProjectRange';

/** FullCalendar view name of the whole-project timeline (story-209). */
export const PROJECT_VIEW = 'resourceTimelineProject';

/**
 * The Project view definition, registered at calendar construction and never conditionally.
 *
 * `visibleRange` is a FUNCTION reading the latest range through `getRange`, not a value. Verified
 * against the real @fullcalendar/core 6.1.20: `setOption('views', ...)` (even followed by
 * `gotoDate`) does NOT re-run the date-profile generator, whereas a function `visibleRange` is
 * re-evaluated by `gotoDate(getDate())`. The range lives only inside this view, so the Month view
 * can never inherit it.
 *
 * FullCalendar's range end is exclusive; `ProjectRange.end` is inclusive, hence the +1 day.
 * `slotDuration` is a Duration object (the string form `'1 day'` was part of the broken Year view).
 */
export const buildProjectView = (getRange: () => ProjectRange | null) => ({
  [PROJECT_VIEW]: {
    type: 'resourceTimeline',
    slotDuration: { days: 1 },
    slotMinWidth: 40,
    slotLabelFormat: [
      { month: 'short', year: 'numeric' },
      { day: 'numeric', weekday: 'narrow' },
    ],
    visibleRange: () => {
      const range = getRange() ?? computeProjectRange({});
      return {
        start: range.start,
        end: toCalendarISOString(addDaysToDate(parseTaskDate(range.end)!, 1)),
      };
    },
  },
});
